<template>
  <div class="checkout-items">
    <validation-observer ref="refReleaseQueueFormObserver" #default="{ invalid }">
      <b-card
          v-for="(release, index) in plannedRelease"
          :key="index"
          class="ecommerce-card"
          no-body
      >
        <!-- Product Image -->
        <div class="item-img">
          <b-link>
            <b-img :alt="`${release.product.slug}-${index}`" :src="release.product.image"/>
          </b-link>
        </div>

        <!-- Product Details: Card Body -->
        <b-card-body>
          <div class="item-name">
            <h6 class="mb-0">
              <b-link class="text-body">
                {{ release.product.name }} - <span class="text-success">{{ release.available_qty }} disponible(s)</span>
              </b-link>
            </h6>
            <!-- <span class="item-company">Par <b-link class="company-name">{{ product.brand }}</b-link></span> -->
            <span class="item-company"
            >Par
              <b-link class="company-name">{{
                  release.product.brand ? release.product.brand.name : "-"
                }}</b-link></span
            >
          </div>
          <hr/>
          <b-row align-v="center">
            <b-col cols="3">
              <span class="quantity-title">Qté:</span>
            </b-col>
            <b-col cols="6">
              <validation-provider
                  #default="{ errors }"
                  :rules="`required|numeric|max_value:${release.available_qty}`"
                  :name="`Quantité ${index + 1}`"
              >
                <b-form-group :name="`Quantité ${index + 1}`">
                  <b-form-input
                      v-model="release.qty"
                      :disabled="release.available_qty <= 0"
                      :state="errors.length === 0"
                      class="form-control ml-75"
                  />
                  <b-form-invalid-feedback :state="errors.length === 0">
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
        </b-card-body>

        <!-- Product Options/Actions -->
        <div class="item-options text-center">
          <b-button
              :disabled="isLoading"
              class="mt-1 remove-wishlist"
              variant="light"
              @click="removeProductFromReleaseList(release.stock, release.product)"
          >
            <feather-icon class="mr-50" icon="XIcon"/>
            <span>Retirer</span>
          </b-button>
        </div>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import {
  BButton,
  BCard,
  BCardBody,
  BCol,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BImg,
  BLink,
  BRow,
} from "bootstrap-vue";
import store from "@/store";
import {computed, ref, watch} from "@vue/composition-api";
import {formatDate} from "@core/utils/filter";
import {useToast} from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
  name: "StockViewReleaseProductStepCartProducts",
  components: {
    BFormGroup,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    BCol,
    BRow,
    BFormInput,
    BCard,
    BCardBody,
    BLink,
    BImg,
    BButton,
    // BBadge,
  },
  setup() {
    const toast = useToast();
    const isLoading = ref(false);
    const refReleaseQueueFormObserver = ref(null);
    const plannedRelease = computed(() => store.getters["stock/release_products"]);

    const showToast = (title, icon, variant) => {
      toast({
        component: ToastificationContent,
        props: {
          title: title,
          icon: icon,
          variant: variant,
        },
      });
    };
    const removeProductFromReleaseList = async (stock, product) => {
      isLoading.value = true;
      try {
        await store.dispatch('stock/removeProductFromReleaseQueue', {stockId: stock.uid, productId: product.uid});
        showToast("Le produit a été retiré de la liste d'attente avec succès.", "CoffeeIcon", "success");
      } catch (error) {
        if (error && typeof error === 'string') {
          showToast(error, "AlertTriangleIcon", "danger");
        } else {
          showToast(`Le produit ${product.name} n'a pas pu être retiré à la liste de sortie.`, "AlertTriangleIcon", "danger");
        }
      } finally {
        isLoading.value = false;
      }
    };


    return {
      isLoading,
      refReleaseQueueFormObserver,
      plannedRelease,

      removeProductFromReleaseList,

      // Filter
      formatDate,
    };
  },
};
</script>
